import service from '@/utils/request';


// 会员商品列表
export function memberProductList (data) {
  return service({
    url: '/v1/memberPay/memberProductList',
    method: 'get',
    params: data
  })
}


// 先判断能不能购买会员(有未过期的手动设置的会员时不能购买) true能购买 false不能购买
export function canBuyMember (data) {
  return service({
    url: '/v1/memberPay/canBuyMember',
    method: 'get',
    params: data
  })
}


// 诺诺创建订单接口，PC端使用
export function memberNuonuoCreate (data) {
  return service({
    url: '/v1/memberRechargeOrder/nuonuoCreate',
    method: 'post',
    data: data
  })
}

// 诺诺支付
export function getMemberQrImg (data) {
  return service({
    url: '/v1/memberPay/nuonuo/getQrImg',
    method: 'get',
    params: data
  })
}

// 诺诺处理已支付订单接口
export function memberDealNuonuoPayedOrder (data) {
  return service({
    url: '/v1/memberRechargeOrder/dealNuonuoPayedOrder',
    method: 'post',
    data: data
  })
}



// 根据orderNo取消订单接口
export function cancelMemberOrder (data) {
  return service({
    url: '/v1/memberRechargeOrder/cancel',
    method: 'get',
    params: data
  })
}



// 我的会员状态
export function myMemberStatus (data) {
  return service({
    url: '/v1/user/my',
    method: 'get',
    params: data
  })
}
